// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"style_dashboard__20yj3","studentsSkeleton":"style_studentsSkeleton__3xoLh"};